<template>
  <div class="password-reset-mail-sent-section">
    <h4 class="password-reset-mail-sent-section__title">
      {{ $t('PasswordResetPage.MailSentPage.title') }}
    </h4>
    <p class="password-reset-mail-sent-section__message">
      {{ $t('PasswordResetPage.MailSentPage.message') }}
    </p>
    <p
      class="password-reset-mail-sent-section__attention"
      v-html="$t('PasswordResetPage.MailSentPage.attention')"
    ></p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * パスワードリセット 認証メール送信完了 セクション
 */
export default defineComponent({
  name: 'PasswordResetMailSentSection',
})
</script>

<style lang="scss" scoped>
.password-reset-mail-sent-section {
  width: 100%;
  padding: 80px min(#{convertPXtoVW(14)}, 14px) 0;
  text-align: center;

  &__title {
    @include fontSetTextMedium(17);
  }

  &__message {
    margin-top: 24px;
    @include fontSetTextMedium();
  }
}
</style>

<style lang="scss">
.password-reset-mail-sent-section {
  &__message {
    letter-spacing: 0.04em;
  }

  &__attention {
    margin-top: 22px;
    @include fontSetTextSmall();

    line-height: 1.4;
    color: $gray50;
  }
}
</style>
